export default "__VITE_ASSET__CN4mClnq__"